import { CellValue } from '../types';

function cellToText(value: CellValue): string {
  if (value === null || value === undefined) return '';
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  }
  return String(value);
}

export function buildSearchIndex(rows: Record<string, CellValue>[], headers: string[]): string[] {
  return rows.map(row =>
    headers
      .map(header => cellToText(row[header]))
      .join(' ')
      .toLowerCase(),
  );
}
